import { render, staticRenderFns } from "./PedidosTable.vue?vue&type=template&id=20f5b45e&scoped=true&"
import script from "./PedidosTable.vue?vue&type=script&lang=js&"
export * from "./PedidosTable.vue?vue&type=script&lang=js&"
import style0 from "./PedidosTable.vue?vue&type=style&index=0&id=20f5b45e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f5b45e",
  null
  
)

export default component.exports